module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/zdCHhc/tc-custom/9781607053477.jpg?1712927412300",
      "alt": "This image is the cover for the book Ricky Tims Convergence Quilts"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Ricky Tims Convergence Quilts\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Become a fabulous quilt artist - the fun, easy way!  Popular quilting expert Ricky Tims presents an imaginative, new piecing technique that quilters will adore! Convergence quilts feature two or more fabrics cut into strips, sewn together, then cut and pieced again. Nothing could be simpler - or more magical! Ricky offers lots of creative guidelines but no hard-and-fast rules, so every Convergence quilt is a unique work of art.  • 4 projects walk you through the steps of making Convergence quilts • Quilts look complex but are fun, easy, and, best of all, creative to make • Use any fabric from commercial prints to hand-dyed • Add decorative touches such as appliqué to dress up your projects • An infinite number of looks from one ingenious technique")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Ricky Tims\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Published by C&T Publishing, Inc.,\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0